import { Link } from '@chakra-ui/react';
import { Colors, Icon, Text } from '@mercator-gcp/grout';
import { FlexRow } from 'components/layout/FlexRow';
import { useCrmPushStatus } from 'hooks/useCrmPush';
import { useActiveCrmConnection } from 'hooks/useOneAuthConnections';
import { CrmResourceType } from 'services/API/OneAuthAPI';

const listItemContentStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  borderRadius: '4px',
  gap: 'padding_8',
  _hover: {
    backgroundColor: Colors.ArmyGreen100,
  },
  width: '100%',
  padding: 'padding_8',
};

type Props = {
  resourceType: CrmResourceType;
  resourceId: string;
};

// Menu action linking to the CRM record this project/document was pushed to.
// Renders nothing until the resource has been pushed and a record URL exists,
// so it appears both right after a push and on every later visit.
const CrmRecordLink = ({ resourceType, resourceId }: Props) => {
  const { connection } = useActiveCrmConnection();
  const { data: pushStatus } = useCrmPushStatus(
    resourceType,
    resourceId,
    Boolean(connection),
  );

  if (!pushStatus?.pushed || !pushStatus.crmRecordUrl) {
    return null;
  }

  const platformLabel = connection?.title || pushStatus.platform || 'CRM';
  const recordLabel = pushStatus.crmObjectType || 'record';

  return (
    <Link
      href={pushStatus.crmRecordUrl}
      target="_blank"
      rel="noopener noreferrer"
      sx={{ textDecoration: 'none', _hover: { textDecoration: 'none' } }}
    >
      <FlexRow sx={listItemContentStyle} cursor="pointer">
        <Icon name={Icon.Name.ArrowDiagonal} fill={Colors.ForestGreen900} />
        <Text.BodyBold>
          View {recordLabel} in {platformLabel}
        </Text.BodyBold>
      </FlexRow>
    </Link>
  );
};

export default CrmRecordLink;
